<template>
	<div class="costs-summary-table">
		<costs-summary-title :module-number="''" :number-of-modules="numberOfModules"
			:show-print-info="showPrintInfo"/>

		<costs-summary-headers/>

		<costs-summary-row
			text="Z dotacji"
			:value="formatMoney(costsSummary.dotation)"
			:index="1"
		></costs-summary-row>

		<costs-summary-row
			text="Inne środki finansowe ogółem"
			:index="2"
			:value="formatMoney(financialContribution)"
		></costs-summary-row>

		<costs-summary-sub-row
			text="Środki finansowe własne"
			:index="2.1"
			:value="formatMoney(costsSummary.ownFinancialContribution)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Świadczenia pieniężne od odbiorców"
			:index="2.2"
			:value="formatMoney(costsSummary.moneyFromRecipients)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Środki finansowe z innych źródeł publicznych"
			:index="2.3"
			:value="formatMoney(costsSummary.otherPublicSource)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Pozostałe"
			:index="2.4"
			:value="formatMoney(costsSummary.other)"
		></costs-summary-sub-row>

		<costs-summary-row
			text="Wkład osobowy i rzeczowy ogółem"
			:index="3"
			:value="formatMoney(ownContribution)"
		></costs-summary-row>

		<costs-summary-sub-row
			text="Wkład osobowy"
			:index="3.1"
			:value="formatMoney(costsSummary.ownHumanContribution)"
		></costs-summary-sub-row>

		<costs-summary-sub-row
			text="Wkład rzeczowy"
			:index="3.2"
			:value="formatMoney(costsSummary.ownContributionInKind)"
		></costs-summary-sub-row>

		<costs-summary-row
			text="Ogółem"
			:index="4"
			:value="formatMoney(totalCosts)"
		></costs-summary-row>

		<costs-summary-row
			text="Udział wkładu własnego w stosunku do kwoty dotacji"
			:index="5"
			:isPercentage="true"
			:value="totalContributionToDotationPercentage"
		></costs-summary-row>

		<costs-summary-row
			text="Udział kwoty dotacji w całkowitych kosztach"
			:index="6"
			:isPercentage="true"
			:value="dotationToWholePercentage"
		></costs-summary-row>

		<costs-summary-row
			text="Udział innych środków finansowych w stosunku do kwoty dotacji"
			:index="7"
			:isPercentage="true"
			:value="financialContributionToDotationPercentage"
		></costs-summary-row>

		<costs-summary-row
			text="Udział wkładu osobowego i wkładu rzeczowego w stosunku do kwoty dotacji"
			:index="8"
			:isPercentage="true"
			:value="ownContributionToDotationPercentage"
		></costs-summary-row>

		<div
			v-for="error in errors"
			:key="error"
		>
			<egranty-validation-error
				:error="error"
			></egranty-validation-error>
		</div>
	</div>
</template>

<script>

	import CostsSummaryRow from "../../offer/components/CostsSummaryRow";
	import CostsSummaryHeaders from "../../offer/components/CostsSummaryHeaders";
	import CostsSummaryTitle from "../../offer/components/CostsSummaryTitle";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";
	import {FinancialSettings} from "@/api/generated/FinancialSettings";
	import {Numbers} from "@/utils/Numbers";
	import CostsSummarySubRow from "../../offer/components/CostsSummarySubRow";
	import {Project} from "@/api/generated/Project";

	export default {
		name: "ProjectCostsSummaryTable",
		components: {
			EgrantyValidationError,
			CostsSummaryTitle,
			CostsSummaryHeaders,
			CostsSummaryRow,
			CostsSummarySubRow,
		},
		computed: {

			totalContributionToDotationPercentage() {
				return Numbers.methods.formatPercentage(this.totalContribution, this.costsSummary.dotation);
			},

			ownContributionToDotationPercentage() {
				return Numbers.methods.formatPercentage(this.ownContribution, this.costsSummary.dotation);
			},

			financialContributionToDotationPercentage() {
				return Numbers.methods.formatPercentage(this.financialContribution, this.costsSummary.dotation);
			},

			dotationToWholePercentage() {
				return Numbers.methods.formatPercentage(this.costsSummary.dotation, this.totalCosts);
			},
			moduleNumber() {
				return this.offerConfiguration.offerModuleNumber ? this.offerConfiguration.offerModuleNumber : 1;
			}
		},

		mounted() {
			// bardziej powinno być nazwane contestData
			FinancialSettings.getOfferData(this,this.contestId,this.moduleNumber,this.mainCountryId,this.mainBidderId, response =>{
				this.financialSettings = response.financialSettings;
				this.financialLimits = response.singleFinancialLimit;
			});
			Project.get(this, this.$route.params.projectId, response => {
							this.costsSummary  = response.costsCalculated.costsSummary;
							this.financialContribution = response.costsCalculated.financialContribution;
							this.ownContribution = response.costsCalculated.ownContribution;
							this.totalContribution = response.costsCalculated.totalContribution;
							this.totalCosts = response.costsCalculated.totalCosts;
			});

		},

		methods: {
			validate() {
				this.errors = [];
				let valid = true;

				let administrativeLimit = this.offerConfiguration.percentAdministrativeLimit;

				if (administrativeLimit !== null) {
					let max;
					let appendix = "";
					if (this.offerConfiguration.percentAdministrativeRelativeToWholeCosts) {
						max = (administrativeLimit / 100) * (this.totalCosts);
						appendix = " w odniesieniu do całości kosztów";
					} else {
						max = (administrativeLimit / 100) * (this.costsSummary.dotation);
						appendix = " w odniesieniu do wnioskowanej dotacji";
					}
					max = Math.round(max * 100) / 100;
					if (this.costsSummary.administrative > max) {
						this.errors.push("Został przekroczony limit kosztów administracyjnych (" + Numbers.methods.formatMoney(max) + " PLN, czyli " + administrativeLimit.toFixed(2).replace(/\./g, ",") + "% " + appendix + ")");
						valid = false;
					}
				}
				let minOwnContributionLimit = this.offerConfiguration.percentMinOwnContributionLimit;

				if (minOwnContributionLimit !== null) {
					let max;
					let appendix = "";
					if (this.offerConfiguration.percentMinOwnContributionRelativeToWholeCosts) {
						max = (minOwnContributionLimit / 100) * (this.totalCosts);
						appendix = " w odniesieniu do całości kosztów";
					} else {
						max = (minOwnContributionLimit / 100) * (this.costsSummary.dotation);
						appendix = " w odniesieniu do wnioskowanej dotacji";
					}
					max = Math.round(max * 100) / 100;
					if (this.totalContribution < max) {
						this.errors.push("Nie został osiągnięty próg wkładu własnego (" + max + " PLN, czyli " + minOwnContributionLimit.toFixed(2).replace(/\./g, ",") + "%" + appendix + ")");
						valid = false;
					}
				}

				let maxOwnContributionLimit = this.offerConfiguration.percentMaxOwnContributionLimit;
				if (maxOwnContributionLimit !== null) {
					let min;
					let appendix = "";
					if (this.offerConfiguration.percentMaxOwnContributionRelativeToWholeCosts) {
						min = (maxOwnContributionLimit / 100) * (this.totalCosts);
						appendix = " w odniesieniu do całości kosztów";
					} else {
						min = (maxOwnContributionLimit / 100) * (this.costsSummary.dotation);
						appendix = " w odniesieniu do wnioskowanej dotacji";
					}
					min = Math.round(min * 100) / 100;
					if (this.totalContribution > min) {
						this.errors.push("Został przekroczony próg wkładu własnego (" + Numbers.methods.formatMoney(min) + " PLN, czyli " + maxOwnContributionLimit.toFixed(2).replace(/\./g, ",") + "%" + appendix + ")");
						valid = false;
					}
				}

				if (!this.financialSettings.fundingPerCountry) {	// limity dofinansowania ustalone globalnie na konkurs
					if (this.costsSummary.dotation > this.financialSettings.maxFunding) {
						this.errors.push("Został przekroczony limit dotacji określony dla tego konkursu (" + Numbers.methods.formatMoney(this.financialSettings.maxFunding) + " PLN)");
						valid = false;
					}
				} else if (!this.financialSettings.fundingPerLegalFormPerCountry) {	// limity dofinansowania ustalone w zależności od kraju
					if (this.financialLimits.maxFunding && this.costsSummary.dotation > this.financialLimits.maxFunding) {
						this.errors.push("Został przekroczony limit dotacji dla tego państwa (" + Numbers.methods.formatMoney(this.financialLimits.maxFunding) + " PLN)");
						valid = false;
					}
				} else {	// limity dofinansowania ustalone w zależności od kraju i formy prawnej

					if (this.financialLimits.maxFunding && this.costsSummary.dotation > this.financialLimits.maxFunding) {
						this.errors.push("Został przekroczony limit dotacji dla tego państwa wyznaczony dla tej formy prawnej (" + Numbers.methods.formatMoney(this.financialLimits.maxFunding) + " PLN)");
						valid = false;
					}
				}


				return valid;
			},

		},

		data() {
			return {
				errors: [],
				costsSummary: {
					administrative: 0,
					dotation: 0,
					ownFinancialContribution: 0,
					ownContributionInKind: 0,
					ownHumanContribution: 0,
					moneyFromRecipients: 0,
					other: 0,
					otherPublicSource: 0,
				},
				financialContribution : 0,
				ownContribution : 0,
				totalContribution : 0,
				totalCosts : 0,
				firstModuleCostsSummary: {},
				firstModuleTotalCosts: 0,
				financialSettings: undefined,
				countrySettings: undefined,
				financialLimits: undefined,
			};
		},


		props: {
			offerConfiguration: Object,
			mainCountryId: {},
			mainBidderId: {},
			contestId: {},
			numberOfModules: {
				default: 0
			},
			showPrintInfo: {
				type: Boolean, default: false
			}
		},

		mixins: [
			Numbers,
		],
	};
</script>

<style scoped>

</style>